import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link, Typography } from '@mui/material';

import { useRequestUrl } from '~/hooks/useRequestUrl';

interface IRequestLink {
  requestId: string;
  disabled: boolean;
  children: React.ReactNode;
}

export const RequestLink: React.FC<IRequestLink> = (props) => {
  const { requestId, disabled, children } = props;
  const requestUrl = useRequestUrl();

  if (!disabled) {
    return (
      <Link component={RouterLink} to={requestUrl({ requestId })} variant="h4" sx={{ display: 'block', fontWeight: 700 }}>
        {children}
      </Link>
    );
  }
  return (
    <Typography variant="h4" sx={{ fontWeight: 700, color: ({ palette: { text } }) => text.secondary }}>
      {children}
    </Typography>
  );
}
